/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filesconfirmed1Inputs */

const en_filesconfirmed1 = /** @type {(inputs: Filesconfirmed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`✓ Confirmed`)
};

const pt_filesconfirmed1 = /** @type {(inputs: Filesconfirmed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`✓ Confirmado`)
};

/**
* | output |
* | --- |
* | "✓ Confirmed" |
*
* @param {Filesconfirmed1Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const filesconfirmed1 = /** @type {((inputs?: Filesconfirmed1Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filesconfirmed1Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_filesconfirmed1(inputs)
	return pt_filesconfirmed1(inputs)
});
export { filesconfirmed1 as "filesConfirmed" }